'use client';
import useNavigationContext from '@susu/custom-made/providers/hooks/useNavigationContext';
import './previewSliderTheme.scss';

import { Section } from '@susu/custom-made/utils/navigation';
import { useEffect, useRef } from 'react';
import Slider from 'react-slick';
import useGlobalContext from '@susu/custom-made/providers/hooks/useGlobalContext';
import cn from 'classnames';
import { PREVIEW_SLIDER_TEST_IDS } from '@susu/custom-made/utils/testIds/preview.testIds';

function SlickArrowButton({
  currentSlide,
  slideCount,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  currentSlide?: number;
  slideCount?: number;
}) {
  return <button {...props} />;
}

export default function PreviewSlider({
  sliderTogoIndex,
  hidden = false,
  children,
}: Readonly<{
  sliderTogoIndex: number | null;
  hidden?: boolean;
  children: React.ReactNode[];
}>) {
  const sliderRef = useRef<Slider | null>(null);
  const { section } = useNavigationContext();
  const { isPreviewZoomed } = useGlobalContext();

  useEffect(() => {
    if (sliderTogoIndex !== null) {
      sliderRef.current?.slickGoTo(sliderTogoIndex);
    }
  }, [sliderTogoIndex]);

  return (
    <div className={cn("preview-slider-container", {hidden})} data-testid={PREVIEW_SLIDER_TEST_IDS.PREVIEW_SLIDER_CONTAINER}>
      <div className="slider-container">
        <Slider
          infinite={false}
          slidesToShow={1}
          slidesToScroll={1}
          adaptiveHeight={false}
          arrows={isPreviewZoomed || section !== Section.Fabric ? false : children.length > 1}
          prevArrow={<SlickArrowButton data-testid={PREVIEW_SLIDER_TEST_IDS.PREVIOUS_ARROW} />}
          nextArrow={<SlickArrowButton data-testid={PREVIEW_SLIDER_TEST_IDS.NEXT_ARROW} />}
          swipe={false}
          ref={slider => {
            sliderRef.current = slider;
          }}
        >
          {children.map((child, key) => {
            return (
              <div className="slide-image-container" key={key}>
                {child}
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}
